const body = qs('body')

/* Open Cart */

const cartToggles = qsa('[data-cart-toggle]')

cartToggles.forEach((toggle) => {
	toggle.addEventListener('click', (e) => {
		e.preventDefault()
		cartToggle()
		searchToggle('close')
		navToggle('close')
		headerInner.classList.add('active')
	})
})

const searchToggles = qsa('[data-search-toggle]')

searchToggles.forEach((toggle) => {
	toggle.addEventListener('click', (e) => {
		e.preventDefault()
		searchToggle()
		cartToggle('close')
		navToggle('close')
		headerInner.classList.add('active')
	})
})

const detailLinks = [...qsa('details a'), ...qsa('details button')]

detailLinks.forEach((link) => {
	link.addEventListener('click', (e) => {
		e.stopPropagation()
	})
})

/* Details Animator — plays the base.css .closing exit animation (@keyframes close, 0.4s) on close,
   without the mobile tap-flicker. Bind to the <summary> only (so clicks on the open content no longer
   close it), and ignore re-taps while a close is already animating. */
const details = document.querySelectorAll('details')

details.forEach((targetDetail) => {
	const summary = targetDetail.querySelector('summary')
	if (!summary) return
	summary.addEventListener('click', function (e) {
		if (targetDetail.classList.contains('closing')) {
			e.preventDefault()
			return
		}
		if (targetDetail.hasAttribute('open')) {
			e.preventDefault()
			targetDetail.classList.add('closing')
			setTimeout(() => {
				targetDetail.removeAttribute('open')
				targetDetail.classList.remove('closing')
			}, 400)
		}
	})
})

/* Liquid Ajax Cart */

liquidAjaxCart.subscribeToCartAjaxRequests((state, subscribeToResult) => {
	if (state.requestType == 'add') {
		const form = state.info.initiator
		let btnInner = ''

		const container = Array.from(
			form.querySelectorAll('[data-adding-container]')
		)
		const button = form.querySelector('button[type="submit"]')

		const btn = [...container, button][0]

		if (btn && !btn.dataset.hideAdding) {
			btnInner = btn.innerHTML

			btn.innerHTML = 'Adding'
		}

		subscribeToResult((state) => {
			if (state.responseData && state.responseData.ok) {
				cartToggle('open')
				mobileHamburger.classList.add('active')
				mobileHamburger.dataset.mobileToggle = 'cart'
				headerInner.classList.add('active')
			}

			if (btn && btnInner) {
				btn.innerHTML = btnInner
			}
		})
	}
})

const upsellTiles = qsa('[data-upsell-tile]')

if (upsellTiles.length > 0) {
	const syncUpsellTiles = (cart) => {
		const productIds = ((cart && cart.items) || []).map((item) =>
			String(item.product_id)
		)

		upsellTiles.forEach((tile) => {
			const added = productIds.includes(tile.dataset.upsellProductId)

			tile.classList.toggle('product-upsell-item__wrapper--added', added)

			const addButton = tile.querySelector('.product-upsell-item__add')
			if (addButton) {
				addButton.disabled = added
			}
		})
	}

	liquidAjaxCart.subscribeToCartStateUpdate((state) =>
		syncUpsellTiles(state.cart)
	)
}

/* Header Navigation Interactions */

//todo refactor all modal state to use one function

const header = qs('#header')
const navigationToggles = qsa('[data-navigation-toggle]')
const headerBg = qs('#headerBg')
const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)')

const NAV_PANEL_TRANSITION = 450
const NAV_CLOSE_GRACE = 120

const navigationPointer = { x: -1, y: -1 }
let navigationCloseTimer = null
let navigationOpenedAt = 0

document.addEventListener(
	'pointermove',
	(e) => {
		navigationPointer.x = e.clientX
		navigationPointer.y = e.clientY
	},
	{ passive: true }
)

function navigationPanel(toggle) {
	return qs(`[data-navigation-item="${toggle.dataset.navigationToggle}"]`)
}

function openNavigationToggle() {
	return qs('[data-navigation-toggle][aria-expanded="true"]')
}

function syncNavigationState() {
	const open = openNavigationToggle()
	header.classList.toggle('active', !!open)
	return open
}

function pointerInsideHeader() {
	if (navigationPointer.x < 0) return false

	const under = document.elementFromPoint(
		navigationPointer.x,
		navigationPointer.y
	)
	return !!under && header.contains(under)
}

function cancelNavigationClose() {
	if (navigationCloseTimer === null) return
	clearTimeout(navigationCloseTimer)
	navigationCloseTimer = null
}

function scheduleNavigationClose() {
	cancelNavigationClose()

	const sinceOpen = performance.now() - navigationOpenedAt
	const delay = Math.max(NAV_CLOSE_GRACE, NAV_PANEL_TRANSITION - sinceOpen)

	navigationCloseTimer = setTimeout(() => {
		navigationCloseTimer = null
		if (pointerInsideHeader()) return
		closeActiveNavigation()
	}, delay)
}

function closeNavigation(toggle) {
	const panel = navigationPanel(toggle)

	cancelNavigationClose()

	panel && panel.classList.remove('active')
	toggle.classList.remove('active')
	toggle.setAttribute('aria-expanded', 'false')

	syncNavigationState()
}

function openNavigation(toggle) {
	const panel = navigationPanel(toggle)
	if (!panel) return false

	cancelNavigationClose()

	navigationToggles.forEach((other) => {
		if (other !== toggle && other.getAttribute('aria-expanded') === 'true') {
			closeNavigation(other)
		}
	})

	const wasOpen = panel.classList.contains('active')

	panel.classList.add('active')
	toggle.classList.add('active')
	toggle.setAttribute('aria-expanded', 'true')
	if (!wasOpen) navigationOpenedAt = performance.now()

	syncNavigationState()
	return true
}

function closeActiveNavigation() {
	const openToggle = openNavigationToggle()
	openToggle && closeNavigation(openToggle)
	return openToggle
}

function toggleNavigation(toggle) {
	if (toggle.getAttribute('aria-expanded') === 'true') {
		closeNavigation(toggle)
	} else {
		openNavigation(toggle)
	}
}

navigationToggles.forEach((toggle) => {
	toggle.addEventListener('mouseenter', () => {
		if (!hoverCapable.matches) return

		if (!openNavigation(toggle)) closeActiveNavigation()
	})

	toggle.addEventListener('click', (e) => {
		const panel = navigationPanel(toggle)

		if (!panel) return

		if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return

		e.preventDefault()

		const wasOpen = toggle.getAttribute('aria-expanded') === 'true'
		toggleNavigation(toggle)

		if (e.detail === 0 && !wasOpen) {
			const focusable = panel.querySelector('a[href], button:not([disabled])')
			focusable && focusable.focus()
		}
	})
})

header.addEventListener('mouseenter', cancelNavigationClose)

header.addEventListener('mouseleave', () => {
	if (!hoverCapable.matches) return
	scheduleNavigationClose()
})

headerBg.addEventListener('mouseenter', () => {
	scheduleNavigationClose()
})

headerBg.addEventListener('click', (e) => {
	e.preventDefault()
	closeActiveNavigation()
})

// Escape closes the open mega menu and returns focus to its trigger.
document.addEventListener('keydown', (e) => {
	if (e.key !== 'Escape') return
	const openToggle = closeActiveNavigation()
	openToggle && openToggle.focus()
})

// Tabbing away from both the trigger and its panel closes the mega menu,
// so keyboard users aren't left with a panel stuck open behind them.
document.addEventListener('focusout', (e) => {
	const openToggle = openNavigationToggle()
	if (!openToggle) return

	const panel = navigationPanel(openToggle)
	const next = e.relatedTarget

	if (next && (openToggle.contains(next) || (panel && panel.contains(next)))) {
		return
	}

	closeNavigation(openToggle)
})

const mobileHamburger = qs('#mobileHamburger')
const mobileNavigation = qs('#mobileNavigation')
const mobileHeaderToggles = qsa('[data-header-toggle]')

mobileHeaderToggles.forEach((btn) => {
	btn.addEventListener('click', (e) => {
		e.preventDefault()
		const active = mobileHamburger.classList.contains('active')
		const element = btn.dataset.headerToggle
		const current = mobileHamburger.dataset.mobileToggle

		if (!active) {
			mobileHamburger.classList.toggle('active')
		} else {
			if (element == current) {
				mobileHamburger.classList.remove('active')
			}
		}

		mobileHamburger.dataset.mobileToggle = element
	})
})

mobileHamburger.addEventListener('click', (e) => {
	e.preventDefault()
	const current = mobileHamburger.dataset.mobileToggle
	mobileHamburger.classList.toggle('active')
	const active = mobileHamburger.classList.contains('active')

	if (!active) {
		body.classList.remove('disable-scroll')
		if (current == 'nav') {
			navToggle('close')
		}
	} else {
		if (current == 'nav') {
			navToggle('open')
		}
	}

	searchToggle('close')
	cartToggle('close')

	mobileHamburger.dataset.mobileToggle = 'nav'
})
const mobileNavigatioNMenuToggles = qsa('[data-mobile-navigation-button]')
mobileNavigatioNMenuToggles.forEach((toggle) => {
	toggle.addEventListener('click', (e) => {
		const title = toggle.dataset.mobileNavigationButton
		const exToggle = qs('[data-mobile-navigation-button].active')
		const content = qs(`[data-mobile-navigation-item="${title}"]`)
		const exContent = qs('[data-mobile-navigation-item].active')

		if (content && exContent != content) {
			toggle.classList.add('active')
			toggle && toggle.setAttribute('aria-expanded', true)

			content.classList.add('active')
			exContent && exContent.classList.remove('active')
			exToggle && exToggle.classList.remove('active')
			exToggle && exToggle.setAttribute('aria-expanded', false)
		}
	})
})

/* Product Card Buy Now Button */

const buyNowButtons = qsa('[data-product-card-buy-now]')

buyNowButtons.forEach((btn) => {
	btn.addEventListener('click', (e) => {
		e.preventDefault()

		let btnInner = btn.innerHTML

		const card = btn.closest('form')
		const id = qs('input[name="id"]', card).value

		btn.innerHTML = 'Adding'

		if (id) {
			fetch('/cart/add.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					id: id,
					quantity: 1
				})
			}).then(() => {
				btn.innerHTML = btnInner
				window.location.href = '/checkout'
			})
		}
	})
})

/* enterview */

let reveals = qsa('.reveal')

if (reveals.length > 0) {
	enterView({
		selector: '.reveal',
		enter: (el, i) => {
			el.classList.add('entered')
		},
		exit: (el) => {
			el.classList.remove('entered')
		},
		offset: 0.1
	})
}

function updateReveals() {
	enterView({
		selector: '.reveal',
		enter: (el, i) => {
			el.classList.add('entered')
		},
		exit: (el) => {
			el.classList.remove('entered')
		},
		offset: 0.1
	})
}

/* Ajaxination */
var endlessScroll = new Ajaxinate({
	container: '#paginationContainer',
	pagination: '#paginationButton',
	method: 'click',
	callback: updateReveals
})

/* Load video on enter - IntersectionObserver skips hidden (display: none, closed dialog) videos */

const llVideos = document.querySelectorAll('.video-ll')

if (llVideos.length > 0) {
	const tryPlay = (el) => {
		const p = el.play()
		if (p) p.catch(() => {})
	}

	const llObserver = new IntersectionObserver(
		(entries) => {
			entries.forEach(({ target, isIntersecting }) => {
				if (!isIntersecting) {
					if (!target.paused) target.pause()
					return
				}

				if (!target.dataset.llLoaded) {
					target.dataset.llLoaded = 'true'
					target.preload = 'auto'
					// play() clears the poster, so wait for frames or the slot goes blank
					target.addEventListener('canplay', () => tryPlay(target))
					target.load()
					return
				}

				if (target.readyState >= 3) tryPlay(target)
			})
		},
		{ rootMargin: '100px', threshold: 0.1 }
	)

	llVideos.forEach((el) => llObserver.observe(el))
}

/* Header Headroom */

const localization = qs('#localizationSelector')

const headroomOptions = {
	offset: {
		up: 50,
		down: 100
	},
	classes: {
		pinned: 'header-wrapper--pinned',
		unpinned: 'header-wrapper--unpinned',
		top: 'header-wrapper--top'
	},
	onUnpin: () => {
		localization.classList.remove('active')
		header.classList.remove('active')
	}
}
const headroom = new Headroom(header, headroomOptions)
headroom.init()

/* Free-scroll defaults for multi-card sliders (CU-86d40kwup).
   Touch devices get cssMode: the browser's own scroller runs on the compositor
   thread instead of JS transforms on the main thread, so the drag stays smooth
   while the main thread is busy, and native direction locking stops a diagonal
   swipe from dragging the page up/down. Snapping is switched off in main.css
   (.swiper-css-mode > .swiper-wrapper). cssMode ignores speed/effect/loop/
   freeMode/mousewheel.
   Mice keep Swiper's freeMode - cssMode has no click-and-drag. */

const freeScroll = {
	...(matchMedia('(pointer: coarse)').matches
		? {
				cssMode: true,
				allowTouchMove: false,
				freeMode: { enabled: true },
				updateOnWindowResize: false
			}
		: {
				freeMode: {
					enabled: true,
					momentum: true,
					momentumRatio: 0.8,
					momentumVelocityRatio: 0.8,
					momentumBounce: false
				}
			}),
	on: {
		afterInit(swiper) {
			if (!swiper.params.cssMode) return
			swiper.update = () => {
				swiper.updateSize()
				swiper.updateSlides()
				swiper.updateProgress()
				swiper.updateSlidesClasses()
			}
		},
		'setTranslate paginationUpdate update resize'(swiper) {
			const bars = [].concat(swiper.pagination.el || [])
			if (!bars.length) return

			const snaps = swiper.snapGrid.length
			const progress = Math.min(Math.max(swiper.progress || 0, 0), 1)
			const scale = snaps > 1 ? (1 + progress * (snaps - 1)) / snaps : 1

			bars.forEach((bar) => {
				qsa('.swiper-pagination-progressbar-fill', bar).forEach((fill) => {
					fill.style.transform = `translate3d(0,0,0) scaleX(${scale}) scaleY(1)`
					fill.style.transitionDuration = `${swiper.progressBarDuration || 0}ms`
				})
			})
		},
		setTransition(swiper, duration) {
			swiper.progressBarDuration = duration
		}
	}
}

/* Homepage Hero Landing Swiper */

const heroLandingSwipers = qsa('[data-hero-swiper]')

heroLandingSwipers.forEach((sw) => {
	const desktopPagination = qs('[data-pagination]', sw)
	const mobilePagination = qs('[data-mobile-pagination]', sw)

	const nextEl = qs('[data-next-button]', sw)
	const prevEl = qs('[data-prev-button]', sw)

	const delay = sw.dataset.delay
	const swiper = new Swiper(sw, {
		direction: 'horizontal',
		loop: true,
		slidesPerView: 1,
		speed: 700,
		autoplay: {
			delay: delay ?? 5000
		},
		navigation: {
			nextEl,
			prevEl
		},
		pagination: {
			el: mobilePagination,
			type: 'bullets',
			clickable: true
		},
		breakpoints: {
			768: {
				pagination: {
					el: desktopPagination,
					type: 'progressbar'
				}
			}
		}
	})
})

/* Cards Swiper */

const cardsSwiper = qsa('[data-cards-swiper]')

cardsSwiper.forEach((sw) => {
	const pagination = qs('.progress-bar', sw)
	const swiper = qs('.swiper-container', sw)
	const nextEl = qs('[data-swiper-next]', sw)
	const prevEl = qs('[data-swiper-prev]', sw)
	const slides = qsa('.swiper-slide', sw)
	const slideLength = Number(sw.dataset.slides)
	const mobileSlideLength = Number(sw.dataset.mobileSlides)

	const _swiper = new Swiper(swiper, {
		...freeScroll,
		direction: 'horizontal',
		loop: false,
		autoHeight: false,
		slidesPerView: mobileSlideLength ? mobileSlideLength : 1.7,
		spaceBetween: 12,
		loop: false,
		speed: 700,
		mousewheel: {
			forceToAxis: true
		},
		pagination: {
			el: pagination,
			type: 'progressbar',
			clickable: true
		},
		navigation: {
			nextEl,
			prevEl
		},
		breakpoints: {
			768: {
				slidesPerView: slideLength ? slideLength : slides.length > 5 ? 4 : 4.25
			}
		}
	})
})

// Product Card Swiper

const productCards = qsa('[data-product-card]')

/* The variant images behind the front one are rendered lazy (product-card.liquid)
   so an off-screen card costs one image instead of one per variant. The fade
   effect parks them outside the visible box, so the browser never gets around to
   them on its own - load them as soon as the card is near the viewport, and a
   swatch click still swaps instantly. */

const variantImageObserver = new IntersectionObserver(
	(entries) => {
		entries.forEach(({ isIntersecting, target }) => {
			if (!isIntersecting) return

			qsa('img[loading="lazy"]', target).forEach((img) => {
				img.loading = 'eager'
			})
			variantImageObserver.unobserve(target)
		})
	},
	{ rootMargin: '300px' }
)

productCards.forEach((card) => {
	const cardSwiper = qs('[data-product-card-swiper]', card)

	if (!cardSwiper) return

	variantImageObserver.observe(cardSwiper)

	const swiper = new Swiper(cardSwiper, {
		direction: 'horizontal',
		loop: false,
		allowTouchMove: false,
		nested: true,
		slidesPerView: 1,
		spaceBetween: 1,
		speed: 400,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		}
	})
	const variantSwatches = qsa('[data-variant-swatch]', card)
	const images = qsa('.swiper-slide', card)
	const idInput = qs('[data-variant-id]', card)

	variantSwatches.forEach((swatch) => {
		const id = swatch.dataset.variantSwatch
		const image = images.find((img) => img.dataset.variantImage == id)
		const imageIdx = images.indexOf(image)

		swatch.addEventListener('click', (e) => {
			e.preventDefault()
			if (idInput) {
				idInput.value = id
			}
			swiper.slideTo(imageIdx)
		})
	})
})

const solutionParallax = qsa('[data-solution-parallax]')

solutionParallax.forEach((module) => {
	const items = qs('[data-solution-parallax-items]', module)
	const listener = qs('[data-solution-parallax-listener]', module)
	if (!items || !listener) return

	let wrapperWidth = listener.offsetWidth
	let itemsWidth = items.scrollWidth
	let difference = itemsWidth - wrapperWidth + 48

	function init() {
		wrapperWidth = listener.offsetWidth
		itemsWidth = items.scrollWidth
		difference = itemsWidth - wrapperWidth + 48
	}
	window.addEventListener('resize', init)

	module.addEventListener('mousemove', (e) => {
		const rect = module.getBoundingClientRect()
		const pos = e.clientX - rect.left
		const ratio = (pos / itemsWidth).toFixed(1)
		const movement = difference * (1 - 2 * ratio)

		items.style.transform = `translateX(${movement}px)`
	})

	module.addEventListener('mouseleave', (e) => {
		items.style.transform = `translateX(0px)`
	})
})

/* Hero Reviews Swiper*/

const heroReviewsSwipers = qsa('[data-hero-reviews-swiper]')

heroReviewsSwipers.forEach((module) => {
	const _swiper = qs('.swiper-container', module)
	const pagination = qs('[data-reviews-pagination]')

	const delay = Number(module.dataset.delay)

	if (!_swiper) return

	const swiper = new Swiper(_swiper, {
		slidesPerView: 1,
		pagination: {
			el: pagination,
			type: 'bullets',
			clickable: true
		},
		slidesPerView: 1,
		speed: 400,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		autoplay: {
			delay: delay ?? 5000
		}
	})
})

/* Featured Links Mobile Swiper */

const featuredLinksSwiper = qsa('[data-featured-links-swiper]')

featuredLinksSwiper.forEach((sw) => {
	const pagination = qs('.progress-bar', sw)
	const swiper = qs('.swiper-container', sw)

	new Swiper(swiper, {
		...freeScroll,
		direction: 'horizontal',
		loop: false,
		autoHeight: false,
		slidesPerView: 1.02,
		spaceBetween: 12,
		loop: false,
		speed: 700,
		mousewheel: {
			forceToAxis: true
		},
		pagination: {
			el: pagination,
			type: 'progressbar',
			clickable: true
		}
	})
})

const collectionNavigation = qsa('[data-collection-navigation-slider]')

collectionNavigation.forEach((nav) => {
	const swiper = new Swiper(nav, {
		...freeScroll,
		direction: 'horizontal',
		loop: false,
		autoHeight: false,
		slidesPerView: 1.25,
		loop: false,
		speed: 700,
		mousewheel: {
			forceToAxis: true
		},
		breakpoints: {
			768: {
				slidesPerView: 4.5
			}
		}
	})
})

const mobileCollectionNavigationBtn = qs('#mobileCollectionNavButton')
const mobileCollectionNavigationItems = qs('#mobileCollectionNavItems')

if (mobileCollectionNavigationBtn) {
	mobileCollectionNavigationBtn.addEventListener('click', (e) => {
		if (!mobileCollectionNavigationItems) return
		mobileCollectionNavigationBtn.classList.toggle('active')
		mobileCollectionNavigationItems.classList.toggle('active')
	})
}

const collectionSorting = qs('#collectionSorting')

if (collectionSorting) {
	const collectionSortingBtn = qs('button', collectionSorting)
	collectionSortingBtn.addEventListener('click', (e) => {
		collectionSorting.classList.toggle('active')
	})
}

const blogSection = qs('[data-blog]')
const blogCurrentTags = blogSection
	? (blogSection.dataset.blogCurrentTags || '').split(',').filter(Boolean)
	: []

if (blogSection && blogCurrentTags.length > 0) {
	window.location.replace(
		`${blogSection.dataset.blogUrl}?tags=${blogCurrentTags.join(',')}`
	)
} else if (blogSection) {
	const perPage = parseInt(blogSection.dataset.blogPerPage, 10) || 8
	const blogArticles = qsa('[data-blog-article]', blogSection)
	const blogFeatured = qs('[data-blog-featured]', blogSection)
	const blogEmpty = qs('[data-blog-empty]', blogSection)
	const blogLoadMore = qs('[data-blog-load-more]', blogSection)
	const blogNextPage = qs('[data-blog-next-page]', blogSection)
	const blogPagination = qs('[data-blog-pagination]', blogSection)
	const blogNextPageUrl = blogNextPage ? blogNextPage.href : null
	const blogFilters = qs('[data-blog-filters]', blogSection)
	const blogFilterLinks = qsa('[data-blog-filter]', blogSection)
	const blogFilterAll = qs('[data-blog-filter-all]', blogSection)
	const blogFiltersToggle = qs('[data-blog-filters-toggle]', blogSection)
	const blogFiltersLabel = qs('[data-blog-filters-label]', blogSection)
	const blogAllLabel = blogFiltersLabel ? blogFiltersLabel.textContent.trim() : ''

	let selectedTags = new Set()
	let visibleCount = perPage

	const matchingArticles = () =>
		blogArticles.filter((article) => {
			if (selectedTags.size === 0)
				return !('blogArticleFeatured' in article.dataset)

			return (article.dataset.blogArticleTags || '')
				.split(',')
				.some((tag) => selectedTags.has(tag))
		})

	const readableUrl = (url) => url.toString().replace(/%2C/g, ',')

	const renderArticles = () => {
		const matching = matchingArticles()
		const hasMore = matching.length > visibleCount

		blogArticles.forEach((article) => {
			article.hidden = true
		})
		matching.slice(0, visibleCount).forEach((article) => {
			article.hidden = false
		})

		const hasNextPage = !!blogNextPage && !hasMore && matching.length > 0

		if (blogFeatured) blogFeatured.hidden = selectedTags.size > 0
		if (blogEmpty) blogEmpty.hidden = matching.length > 0
		if (blogLoadMore) blogLoadMore.hidden = !hasMore
		if (blogPagination) blogPagination.hidden = !hasMore && !hasNextPage

		if (blogNextPage) {
			const nextUrl = new URL(blogNextPageUrl)

			if (selectedTags.size > 0) {
				nextUrl.searchParams.set('tags', [...selectedTags].join(','))
			}
			blogNextPage.href = readableUrl(nextUrl)
			blogNextPage.hidden = !hasNextPage
		}

		updateReveals()
	}

	const setCurrent = (link, isActive) => {
		isActive
			? link.setAttribute('aria-current', 'true')
			: link.removeAttribute('aria-current')
	}

	const renderFilters = () => {
		const labels = []

		blogFilterLinks.forEach((link) => {
			const isActive = selectedTags.has(link.dataset.blogFilter)

			if (isActive) labels.push(link.textContent.trim())
			setCurrent(link, isActive)
			link
				.closest('[data-blog-filter-item]')
				.classList.toggle('blog__filters-item--active', isActive)
		})

		if (blogFilterAll) {
			setCurrent(blogFilterAll, selectedTags.size === 0)
			blogFilterAll
				.closest('[data-blog-filter-item]')
				.classList.toggle('blog__filters-item--active', selectedTags.size === 0)
		}

		if (blogFiltersLabel) {
			blogFiltersLabel.textContent = labels.length
				? labels.join(', ')
				: blogAllLabel
		}
	}

	const syncBlogUrl = () => {
		const url = new URL(window.location.href)

		if (selectedTags.size > 0) {
			url.searchParams.set('tags', [...selectedTags].join(','))
		} else {
			url.searchParams.delete('tags')
		}
		history.pushState({}, '', readableUrl(url))
	}

	const readBlogUrl = () => {
		const tags = new URLSearchParams(window.location.search).get('tags') || ''

		selectedTags = new Set(tags.split(',').filter(Boolean))
		visibleCount = perPage
		renderFilters()
		renderArticles()
	}

	blogFilterLinks.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault()

			const tag = link.dataset.blogFilter

			selectedTags.has(tag) ? selectedTags.delete(tag) : selectedTags.add(tag)
			visibleCount = perPage
			syncBlogUrl()
			renderFilters()
			renderArticles()
		})
	})

	if (blogFilterAll) {
		blogFilterAll.addEventListener('click', (e) => {
			e.preventDefault()
			selectedTags.clear()
			visibleCount = perPage
			syncBlogUrl()
			renderFilters()
			renderArticles()
		})
	}

	if (blogLoadMore) {
		blogLoadMore.addEventListener('click', (e) => {
			visibleCount += perPage
			renderArticles()
		})
	}

	window.addEventListener('popstate', readBlogUrl)

	if (blogFiltersToggle) {
		const setBlogFilters = (isOpen) => {
			blogFilters.classList.toggle('active', isOpen)
			blogFiltersToggle.setAttribute('aria-expanded', isOpen)
		}

		blogFiltersToggle.addEventListener('click', (e) => {
			setBlogFilters(!blogFilters.classList.contains('active'))
		})

		document.addEventListener('click', (e) => {
			if (!blogFilters.contains(e.target)) setBlogFilters(false)
		})

		document.addEventListener('keydown', (e) => {
			if (e.key !== 'Escape' || !blogFilters.classList.contains('active')) return

			setBlogFilters(false)
			blogFiltersToggle.focus()
		})
	}

	readBlogUrl()
}

const collectionFeaturedGrid = qsa('[data-collection-featured-grid]')

collectionFeaturedGrid.forEach((grid) => {
	const _swiper = qs('.swiper-container', grid)
	const pagination = qs('.progress-bar', grid)

	const swiper = new Swiper(_swiper, {
		...freeScroll,
		direction: 'horizontal',
		loop: false,
		autoHeight: false,
		slidesPerView: 1.25,
		spaceBetween: 12,
		loop: false,
		speed: 700,
		mousewheel: {
			forceToAxis: true
		},
		pagination: {
			el: pagination,
			type: 'progressbar',
			clickable: true
		}
	})
})

const productCarouselSwiper = qs('#productCarouselWrapper')

if (productCarouselSwiper) {
	const swiperEl = qs('#productCarousel', productCarouselSwiper)
	const thumbnailsEl = qs('#productCarouselThumbnails', productCarouselSwiper)
	const paginationEl = qs('#productCarouselNavigation', productCarouselSwiper)

	const thumbnails = new Swiper(thumbnailsEl, {
		direction: 'vertical',
		autoHeight: false,
		slidesPerView: 'auto',
		spaceBetween: 20,
		loop: false,
		centeredSlides: false,
		watchSlidesProgress: true,
		mousewheel: {
			forceToAxis: true
		},
		navigation: {
			nextEl: '#productCarouselThumbnailsNext',
			prevEl: '#productCarouselThumbnailsPrev'
		}
	})

	const swiper = new Swiper(swiperEl, {
		direction: 'horizontal',
		loop: false,
		autoHeight: false,
		slidesPerView: 1,
		spaceBetween: 1,
		keyboard: {
			enabled: true,
			onlyInViewport: true
		},
		mousewheel: {
			forceToAxis: true
		},
		speed: 400,
		thumbs: {
			swiper: thumbnails
		},
		pagination: {
			el: paginationEl,
			type: 'bullets',
			clickable: true
		}
	})

	const lightboxTrigger = qs('#lightboxTrigger')
	const lightbox = qs('#lightbox')
	const lightboxClose = qs('#lightboxClose')
	const lightboxNextBtn = qs('#lightboxNext')
	const lightboxPrevBtn = qs('#lightboxPrev')
	const lightboxPagination = qs('.lightbox-pagination', lightbox)

	const lightboxThumbnailSwiper = new Swiper('#lightboxThumbnailSwiper', {
		direction: 'vertical',
		slidesPerView: 'auto',
		centeredSlides: false,
		mousewheel: {
			forceToAxis: true
		},
		spaceBetween: 20,
		loop: false,
		watchSlidesProgress: true,
		navigation: {
			nextEl: '#productLightboxCarouselThumbnailsNext',
			prevEl: '#productLightboxCarouselThumbnailsPrev'
		}
	})

	const lightboxMobile = matchMedia('(max-width: 768px)')

	const setCoverZoom = (s) => {
		s.slides.forEach((slide) => {
			const wrap = qs('.swiper-zoom-container', slide)
			const img = wrap && qs('img', wrap)
			if (!img) return
			const ratio = img.offsetWidth
				? Math.max(
						slide.offsetWidth / img.offsetWidth,
						slide.offsetHeight / img.offsetHeight
					)
				: 0
			if (lightboxMobile.matches && ratio > 1) {
				wrap.dataset.swiperZoom = ratio.toFixed(3)
			} else {
				delete wrap.dataset.swiperZoom
			}
		})
	}

	const lightboxSwiper = new Swiper('#lightboxSwiper', {
		slidesPerView: 1,
		centeredSlides: true,
		spaceBetween: 12,
		zoom: {
			minRatio: 1,
			maxRatio: 1.5
		},
		on: {
			slideChange: (s) => s.zoom.out(),
			zoomChange: (s, scale) => {
				s.allowTouchMove = scale <= 1
			},
			resize: setCoverZoom
		},
		thumbs: {
			swiper: lightboxThumbnailSwiper
		},
		navigation: {
			nextEl: lightboxNextBtn,
			prevEl: lightboxPrevBtn
		},
		keyboard: {
			enabled: true
		},
		pagination: {
			el: lightboxPagination,
			type: 'fraction',
			clickable: true
		},
		breakpoints: {
			768: {
				spaceBetween: 0
			}
		}
	})
	if (lightboxTrigger) {
		lightboxTrigger.addEventListener('click', () => {
			const activeSlide = swiper.activeIndex
			lightboxSwiper.slideTo(activeSlide)
			lightbox.showModal()
			setCoverZoom(lightboxSwiper)
			body.classList.add('disable-scroll')
		})

		lightboxClose.addEventListener('click', () => {
			lightbox.close()
		})
	}

	lightbox.addEventListener('close', () => {
		lightboxSwiper.zoom.out()
		body.classList.remove('disable-scroll')
	})
}

// Interactive Gallery

const interactiveGalleries = qsa('[data-interactive-gallery]')

interactiveGalleries.forEach((module) => {
	const steps = qs('[data-step]', module)
	if (!steps) return

	const cursor = qs('[data-cursor]', module)

	steps.addEventListener('click', (e) => {
		e.preventDefault
		let idx = Number(steps.dataset.step)
		const newIndex = idx == 4 ? 1 : idx + 1
		steps.setAttribute('data-step', newIndex)
	})

	steps.addEventListener('mouseover', (e) => {
		cursor.classList.add('active')
	})
	steps.addEventListener('mouseleave', (e) => {
		cursor.classList.remove('active')
	})

	steps.addEventListener('pointermove', (e) => {
		const { offsetX, offsetY } = e
		const elWidth = steps.scrollWidth
		const leftThreshold = elWidth - 400

		cursor.animate(
			{
				left:
					leftThreshold > offsetX ? `${offsetX + 60}px` : `${offsetX - 180}px`,
				top: `${offsetY + 20}px`
			},
			{ duration: 300, fill: 'forwards' }
		)
	})
})

const productFeaturesButtons = qsa('[data-feature-button]')
const productFeaturesImages = qsa('[data-feature-image]')

productFeaturesButtons &&
	productFeaturesButtons.forEach((btn) => {
		btn.addEventListener('click', (e) => {
			e.preventDefault()
			const title = btn.dataset.featureButton
			const ex = qs('[data-feature-button].active')
			const exImage = qs('[data-feature-image].active')
			const image = qs(`[data-feature-image="${title}"]`)
			ex && ex.classList.remove('active')
			exImage && exImage.classList.remove('active')

			image && image.classList.add('active')
			btn.classList.add('active')
		})
	})

/* Callouts choose their interaction model by input capability, not viewport width.
   window.innerWidth put a touch tablet (iPad 11" is 834px CSS in portrait) on the
   pointer path, where a re-tap closes the callout but the modal's Hide button is
   never bound - so a callout could be opened there with no way to close it. */
const canHover = window.matchMedia('(hover: hover)')

productFeaturesImages &&
	productFeaturesImages.forEach((image) => {
		const tooltips = qsa('[data-info-tooltip-toggle]', image)
		const mobileToggles = qsa('[data-mobile-modal-hide]', image)
		const prevButtons = qsa('[data-mobile-toggle-prev]', image)
		const nextButtons = qsa('[data-mobile-toggle-next]', image)
		tooltips.forEach((tip) => {
			tip.addEventListener('click', (e) => {
				const ex = qs(
					'[data-info-tooltip-toggle].active, [data-info-tooltip-toggle].initial-active',
					image
				)
				setTimeout(() => image.classList.add('info-open'), 10)

				if (ex != tip) {
					tip.classList.add('active')
					ex && ex.classList.remove('active')
					ex && ex.classList.remove('initial-active')
				}
				if (ex == tip) {
					if (canHover.matches) {
						tip.classList.remove('active')
						tip.classList.remove('initial-active')
					} else {
						tip.classList.remove('initial-active')
						tip.classList.add('active')
					}
				}
			})
		})

		mobileToggles.forEach((toggle) => {
			toggle.addEventListener('click', (e) => {
				const ex = qs('[data-info-tooltip-toggle].active', image)
				ex && ex.classList.remove('active')
				image.classList.remove('info-open')
			})
		})

		prevButtons.forEach((toggle) => {
			const idx = toggle.dataset.mobileTogglePrev
			const length = tooltips.length

			toggle.addEventListener('click', (e) => {
				const ex = qs('[data-info-tooltip-toggle].active', image)
				ex.classList.remove('active')
				if (idx == 1) {
					tooltips[length - 1].classList.add('active')
				} else {
					tooltips[idx - 2].classList.add('active')
				}
			})
		})
		nextButtons.forEach((toggle) => {
			const idx = toggle.dataset.mobileToggleNext
			const length = tooltips.length

			toggle.addEventListener('click', (e) => {
				const ex = qs('[data-info-tooltip-toggle].active', image)

				ex.classList.remove('active')
				if (idx == length) {
					tooltips[0].classList.add('active')
				} else {
					tooltips[idx].classList.add('active')
				}
			})
		})
	})

const tooltipModules = qsa('[data-tooltip-module]')

tooltipModules.forEach((module) => {
	const productToolTips = qsa('[data-product-tooltip]', module)

	productToolTips &&
		productToolTips.forEach((tip) => {
			tip.addEventListener('mouseover', (e) => {
				e.preventDefault()

				const ex = qs('[data-product-tooltip].active', module)

				ex && ex.classList.remove('active')
				tip.classList.add('active')
			})
		})
})

const productFeaturesSelect = qs('#productFeaturesSelect')

productFeaturesSelect &&
	productFeaturesSelect.addEventListener('change', (e) => {
		const value = e.target.value

		const exImage = qs('[data-feature-image].active')
		const image = qs(`[data-feature-image="${value}"]`)
		exImage && exImage.classList.remove('active')

		image && image.classList.add('active')
	})

const userBenefitsSwipers = qsa('[data-user-benefits-swiper]')

userBenefitsSwipers.forEach((module) => {
	const _swiper = qs('.swiper-container', module)
	const pagination = qs('.progress-bar', module)
	const nextEl = qs('[data-swiper-next]', module)
	const prevEl = qs('[data-swiper-prev]', module)

	const swiper = new Swiper(_swiper, {
		...freeScroll,
		direction: 'horizontal',
		loop: false,
		autoHeight: true,
		slidesPerView: 1.25,
		spaceBetween: 12,
		loop: false,
		speed: 700,
		mousewheel: {
			forceToAxis: true
		},
		pagination: {
			el: pagination,
			type: 'progressbar',
			clickable: true
		},
		navigation: {
			nextEl,
			prevEl
		},
		breakpoints: {
			768: {
				slidesPerView: 4.25
			}
		}
	})
})

const compareKitsCarousel = qsa('[data-compare-kits-swiper]')

compareKitsCarousel.forEach((module) => {
	const _swiper = qs('.swiper-container', module)
	const desktopPagination = qs('[data-pagination]', module)
	const mobilePagination = qs('[data-mobile-pagination]', module)

	const kitItems = qsa('[data-compare-kit-item]', module)
	const itemBtns = qsa('[data-mobile-select-btn]', module)
	const itemVariants = qsa('[data-mobile-variant-item]', module)

	const prevEl = qs('[data-prev-button]', module)
	const nextEl = qs('[data-next-button]', module)

	const handleSlideChange = (e) => {
		const idx = e.activeIndex

		kitItems.forEach((item, i) => {
			item.toggleAttribute('open', i === idx)
		})
		const active = itemVariants[idx]
		const inner = active.dataset.mobileVariantItem
		const ex = qs('[data-mobile-variant-item].active', module)

		if (active != ex) {
			ex.classList.remove('active')
			active.classList.add('active')
			compareKitsMobileSelectBtnInner.innerHTML = inner
		}
	}

	const swiper = new Swiper(_swiper, {
		direction: 'horizontal',
		loop: false,
		autoHeight: false,
		slidesPerView: 1,
		loop: false,
		speed: 700,
		allowTouchMove: true,
		mousewheel: {
			forceToAxis: true
		},
		pagination: {
			el: mobilePagination,
			type: 'bullets',
			clickable: false
		},
		on: {
			activeIndexChange: (e) => handleSlideChange(e)
		},
		navigation: {
			prevEl,
			nextEl
		},
		breakpoints: {
			768: {
				allowTouchMove: true,
				pagination: {
					el: desktopPagination,
					type: 'progressbar',
					clickable: false
				}
			}
		}
	})

	kitItems.forEach((item, i) => {
		item.addEventListener('click', (e) => {
			e.preventDefault()
			swiper.slideTo(i)
		})
	})

	const compareKitsMobileSelectBtn = qs(
		'[data-compare-kits-mobile-select-btn]',
		module
	)
	const compareKitsMobileSelectBtnInner = qs('span', compareKitsMobileSelectBtn)
	const compareKitsMobileSelect = qs(
		'[data-compare-kits-mobile-select]',
		module
	)

	compareKitsMobileSelectBtn.addEventListener('click', () => {
		compareKitsMobileSelect.classList.toggle('active')
	})

	itemBtns.forEach((item, i) => {
		item.addEventListener('click', () => {
			const ex = qs('[data-mobile-variant-item].active', module)
			const exBtn = qs('[data-mobile-select-btn].hidden', module)
			const active = itemVariants[i]
			const inner = item.textContent

			if (active != ex) {
				ex.classList.remove('active')
				exBtn.classList.remove('hidden')

				active.classList.add('active')
				item.classList.add('hidden')
				compareKitsMobileSelectBtnInner.innerHTML = inner
				swiper.slideTo(i)
			}
			compareKitsMobileSelect.classList.remove('active')
		})
	})
})

const videoReviewsSwipers = qsa('[data-video-reviews-swiper]')

videoReviewsSwipers.forEach((module) => {
	const _swiper = qs('.swiper-container', module)
	const desktopPagination = qs('[data-pagination]', module)
	const mobilePagination = qs('[data-mobile-pagination]', module)

	const prev = qs('[data-prev-button]', module)
	const next = qs('[data-next-button]', module)

	const swiper = new Swiper(_swiper, {
		...freeScroll,
		direction: 'horizontal',
		loop: false,
		autoHeight: false,
		loop: false,
		speed: 700,
		spaceBetween: 20,
		slidesPerView: 1.1,
		navigation: {
			prevEl: prev,
			nextEl: next
		},
		mousewheel: {
			forceToAxis: true
		},
		pagination: {
			el: mobilePagination,
			type: 'progressbar',
			clickable: true
		},
		breakpoints: {
			768: {
				slidesPerView: 3,
				pagination: {
					el: desktopPagination,
					type: 'progressbar'
				}
			}
		}
	})
})

const productSpecficationModules = qsa('[data-product-specifications]')

productSpecficationModules.forEach((module) => {
	const _swiper = qs('.swiper-container', module)
	const mobilePagination = qs('[data-mobile-pagination]', module)
	const desktopPagination = qs('[data-pagination]', module)

	const next = qs('[data-next-button]', module)
	const prev = qs('[data-prev-button]', module)

	const swiper = new Swiper(_swiper, {
		direction: 'horizontal',
		loop: false,
		autoHeight: false,
		loop: false,
		speed: 700,
		spaceBetween: 20,
		slidesPerView: 1,
		navigation: {
			nextEl: next,
			prevEl: prev
		},
		mousewheel: {
			forceToAxis: true
		},
		pagination: {
			el: mobilePagination,
			type: 'bullets',
			clickable: true
		},
		breakpoints: {
			768: {
				pagination: {
					el: desktopPagination,
					type: 'progressbar',
					clickable: true
				}
			}
		}
	})
})

/* Product Intersection */
const quickAtc = qs('#productQuickAtc')
const productBreadcrumbs = qs('#productBreadcrumbs')
const productMeta = qs('#product-form')
const footer = qs('#footer')

const headerInner = qs('.header', header)

if (productMeta) {
	const quickAtcObserver = new IntersectionObserver(
		([entry]) => {
			if (!entry.isIntersecting) {
				quickAtc.classList.add('active')
			} else {
				quickAtc.classList.remove('active')
			}
		},
		{
			root: null,
			threshold: 0
		}
	)
	quickAtcObserver.observe(productMeta)

	const mainObserver = new IntersectionObserver(
		([entry]) => {
			if (!entry.isIntersecting) {
				headerInner.classList.remove('header--transparent')
			} else {
				headerInner.classList.add('header--transparent')
			}
		},
		{
			root: null,
			threshold: 0
		}
	)
	mainObserver.observe(productBreadcrumbs)

	const footerObserver = new IntersectionObserver(
		([entry]) => {
			if (!entry.isIntersecting) {
				if (window.scrollY > 200) {
					quickAtc.classList.add('active')
				}
			} else {
				quickAtc.classList.remove('active')
			}
		},
		{
			root: null,
			threshold: 0.1
		}
	)
	footerObserver.observe(footer)
}

const productVideoModules = qsa('[data-product-videos]')

productVideoModules.forEach((module) => {
	const scroller = qs('[data-product-videos-scroller]', module)
	const fill = qs('.swiper-pagination-progressbar-fill', module)
	if (!scroller || !fill) return

	const update = () => {
		const { scrollLeft, scrollWidth, clientWidth } = scroller
		if (!scrollWidth) return

		const max = scrollWidth - clientWidth
		const ratio = clientWidth / scrollWidth
		const progress = max > 0 ? scrollLeft / max : 0
		const scale = Math.min(ratio + (1 - ratio) * progress, 1)

		fill.style.transform = `translate3d(0,0,0) scaleX(${scale}) scaleY(1)`
	}

	scroller.addEventListener('scroll', update, { passive: true })
	window.addEventListener('resize', update)
	update()
})

const productVideoToggles = qsa('[data-product-video-toggle]')
const productVideos = qsa('[data-product-video]')

productVideoToggles.forEach((toggle) => {
	toggle.addEventListener('click', (e) => {
		const idx = toggle.dataset.productVideoToggle
		const modal = qs(`[data-product-video="${idx}"]`)
		if (!modal) return

		const isOpen = toggle.getAttribute('aria-expanded') === 'true'
		const embed = qs('[data-video-embed]', modal)
		const video = qs('video', modal)

		if (isOpen) {
			modal.close()
			toggle.setAttribute('aria-expanded', 'false')
		} else {
			toggle.setAttribute('aria-expanded', 'true')
			modal.showModal()
			if (embed) embed.src = embed.dataset.videoEmbed + (hoverCapable.matches ? '&autoplay=1' : '')
			if (video) video.play().catch(() => {})
		}
	})
})

productVideos.forEach((lightbox) => {
	const closeToggles = qsa('[data-lightbox-close]', lightbox)
	const idx = lightbox.dataset.productVideo
	const toggle = qs(`[data-product-video-toggle="${idx}"]`)
	const video = qs('video', lightbox)
	const embed = qs('[data-video-embed]', lightbox)

	closeToggles.forEach((btn) => {
		btn.addEventListener('click', (e) => {
			lightbox.close()
			toggle.setAttribute('aria-expanded', 'false')
		})
	})

	lightbox.addEventListener('close', (e) => {
		if (video) video.pause()
		if (embed) embed.removeAttribute('src')
	})
})

const adventureCarouselElements = qsa('[data-adventure-carousel]')

adventureCarouselElements.forEach((module) => {
	const swiperEl = qs('.swiper-container', module)

	const swiper = new Swiper(swiperEl, {
		slidesPerView: 1.8,
		spaceBetween: 32,
		centeredSlides: true,
		speed: 3000,
		autoplay: {
			delay: 0
		},
		loop: true,
		effect: 'coverflow',
		autoHeight: true,
		mousewheel: {
			forceToAxis: true
		},
		coverflowEffect: {
			rotate: 0,
			stretch: 40,
			depth: 250,
			modifier: 1,
			scale: 1,
			slideShadows: false
		},

		breakpoints: {
			768: {
				slidesPerView: 4,
				coverflowEffect: {
					rotate: 0,
					stretch: -40,
					depth: 200,
					modifier: 0.6,
					scale: 0.85,
					slideShadows: false
				}
			}
		}
	})
})

const localizationToggles = qsa('[data-localization-toggle]')
const localizationFullscreen = matchMedia('(max-width: 1024px)')

localizationToggles.forEach((toggle) => {
	toggle.addEventListener('click', (e) => {
		e.preventDefault()
		const open = localization.classList.toggle('active')

		if (localizationFullscreen.matches) {
			body.classList.toggle('disable-scroll', open)
		}
	})
})

const competitionProductCarousel = qsa('[data-competition-products-swiper]')

competitionProductCarousel.forEach((module) => {
	const _swiper = qs('.swiper-container', module)
	const pagination = qs('.progress-bar', module)
	const swiper = new Swiper(_swiper, {
		...freeScroll,
		direction: 'horizontal',
		autoHeight: false,
		// loop: true,
		spaceBetween: 12,
		slidesPerView: 1.5,
		mousewheel: {
			forceToAxis: true
		},
		pagination: {
			el: pagination,
			type: 'progressbar',
			clickable: true
		},
		breakpoints: {
			768: {
				slidesPerView: 3
			}
		}
	})
})

const searchItems = qsa('[data-search-results-item]')

searchItems.forEach((search) => {
	const type = search.dataset.searchResultsItem
	const amount = type == 'products' ? 3 : 2
	let idx = amount - 1
	const items = qsa('[data-search-item]', search)

	const btn = qs('[data-search-results-button]', search)

	btn &&
		btn.addEventListener('click', () => {
			idx = idx + amount
			items.forEach((item, i) => {
				if (i <= idx) {
					item.classList.remove('hidden')
				}
			})

			if (idx >= items.length) {
				btn.classList.add('hidden')
			}
		})
})

const handleSearchClick = (el) => {
	const type = el.closest('[data-search-results-item]')
	searchLoadMore(type, el)
}

const searchLoadMore = (searchEl, btn) => {
	const type = searchEl.dataset.searchResultsItem
	const amount = type == 'products' ? 3 : 2

	const _idx = Number(searchEl.dataset.idx)
	const idx = _idx + amount
	const items = qsa('[data-search-item]', searchEl)

	searchEl.dataset.idx = idx

	items.forEach((item, i) => {
		if (i <= idx) {
			item.classList.remove('hidden')
		}
	})

	if (idx >= items.length) {
		btn.classList.add('hidden')
	}
}

function initSearchSwiper() {
	const searchModalSwiper = qsa('[data-search-swiper]')

	searchModalSwiper.forEach((sw) => {
		const swiper = qs('.swiper-container', sw)

		const _swiper = new Swiper(swiper, {
			...freeScroll,
			direction: 'horizontal',
			loop: false,
			autoHeight: false,
			slidesPerView: 2.25,
			spaceBetween: 12,
			loop: false,
			speed: 700,
			mousewheel: {
				forceToAxis: true
			},
			breakpoints: {
				768: {
					slidesPerView: 4
				}
			}
		})
	})
}
initSearchSwiper()

const foundersModules = qsa('[data-founders-module]')

foundersModules.forEach((module) => {
	const cards = qsa('[data-founders-item]', module)

	cards.forEach((card) => {
		card.addEventListener('mouseenter', (e) => {
			const ex = qs('[data-founders-item].active')

			ex && ex.classList.remove('active')
			card.classList.add('active')
		})
		card.addEventListener('click', (e) => {
			const ex = qs('[data-founders-item].active')

			ex && ex.classList.remove('active')
			card.classList.add('active')
		})
	})
})

/* Site Credits Toggle */

const siteCreditsToggles = qsa('[data-credits-toggle]')
const siteCredits = qs('#siteCredits')

siteCreditsToggles.forEach((toggle) => {
	toggle.addEventListener('click', (e) => {
		e.preventDefault()
		siteCredits && siteCredits.classList.toggle('active')
	})
})

/* Play button */

const playVideos = qsa('[data-play]')

playVideos.forEach((el) => {
	const btn = qs('[data-play-btn]', el)
	const video = qs('video', el)
	btn.addEventListener('click', (e) => {
		e.preventDefault()
		btn.classList.add('hidden')
		video.play()
		video.setAttribute('controls', true)
	})

	video.addEventListener('pause', (e) => {
		btn.classList.remove('hidden')
		video.removeAttribute('controls')
	})
})

const xlMediaModules = qsa('[data-xl-media]')

xlMediaModules.forEach((module) => {
	const video = qs('video', module)
	const hide = qs('[data-hide-on-play]', module)

	if (video && hide) {
		video.addEventListener('play', () => {
			hide.classList.add('hidden')
		})
		video.addEventListener('pause', () => {
			hide.classList.remove('hidden')
		})
	}
})

// Cart USP

const cartUsps = qsa('[data-usp-item]')

cartUsps.forEach((usp) => {
	const closeBtn = qs('[data-close-btn]', usp)

	usp.addEventListener('mouseover', (e) => {
		usp.classList.add('active')
	})
	usp.addEventListener('mouseleave', (e) => {
		usp.classList.remove('active')
	})

	closeBtn.addEventListener('click', (e) => {
		e.preventDefault()
		usp.classList.remove('active')
	})
})
